import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, CoursesService, PathsService, PortalConfigurationService, UserManagementService } from '@draeger-academy/common';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { BookingDetails } from '../../../../../../models/bookingDetails';
import { Person } from '../../../../../../models/person';

@Component({
    selector: 'da-lib-booking-detail',
    templateUrl: './account-booking-detail.component.html',
    styleUrls: ['./account-booking-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountBookingDetailComponent implements OnInit {
    @Input() courseId: string;
    @Input() hasDates: boolean;
    private _$bookingDetails: BehaviorSubject<BookingDetails> = new BehaviorSubject<BookingDetails>(null);
    private _$bookingPerson: BehaviorSubject<Person> = new BehaviorSubject<Person>(null);
    private _$billingPerson: BehaviorSubject<Person> = new BehaviorSubject<Person>(null);
    public countryName: string;
    public courseTitle: string;
    linkAccountCourseList: string;
    public salutationData: any;
    public countriesData: any;

    constructor(
        private _coursesService: CoursesService,
        private _pathsService: PathsService,
        public _translateService: TranslateService,
        private _configurationService: ConfigurationService,
        private userService: UserManagementService,
        private _courseService: CoursesService,
        private _portalConfigurationService: PortalConfigurationService
    ) {}

    public get bookingDetails$(): Observable<BookingDetails> {
        return this._$bookingDetails.asObservable();
    }

    public get bookingPerson$(): Observable<Person> {
        return this._$bookingPerson.asObservable();
    }

    public get billingPerson$(): Observable<Person> {
        return this._$billingPerson.asObservable();
    }
    private _$translatedBookingSalutation: BehaviorSubject<string> = new BehaviorSubject<string>('');

    public get translatedBookingSalutation$(): Observable<string> {
        return this._$translatedBookingSalutation.asObservable();
    }
    private _$translatedBookingCountry: BehaviorSubject<string> = new BehaviorSubject<string>('');

    public get translatedBookingCountry$(): Observable<string> {
        return this._$translatedBookingCountry.asObservable();
    }

    private _$translatedBillingSalutation: BehaviorSubject<string> = new BehaviorSubject<string>('');

    public get translatedBillingSalutation$(): Observable<string> {
        return this._$translatedBillingSalutation.asObservable();
    }
    private _$translatedBillingCountry: BehaviorSubject<string> = new BehaviorSubject<string>('');

    public get translatedBillingCountry$(): Observable<string> {
        return this._$translatedBillingCountry.asObservable();
    }

    private _$dateFormat: BehaviorSubject<string> = new BehaviorSubject('');
    public get dateFormat$(): Observable<string> {
        return this._$dateFormat.asObservable();
    }

    private _$status: BehaviorSubject<string> = new BehaviorSubject('');
    public get status$(): Observable<string> {
        return this._$status.asObservable();
    }

    ngOnInit() {
        this._courseService.languageSelected.subscribe((language) => {
            this.translateSalutationsAndCountries(this._$bookingPerson.getValue(), this._$billingPerson.getValue());
        });
        this.linkAccountCourseList = this._pathsService.getAccountCourseList();

        if (this.courseId) {
            this._coursesService.getBookingDetails(this.courseId).then(
                (bookingDetails) => {
                    if (bookingDetails) {
                        this._$bookingDetails.next(bookingDetails);
                        this._$bookingPerson.next(bookingDetails.bookingPerson);
                        this._$billingPerson.next(bookingDetails.billingPerson);
                        if (bookingDetails.bookingPerson && bookingDetails.billingPerson) {
                            this.translateSalutationsAndCountries(this._$bookingPerson.getValue(), this._$billingPerson.getValue());
                        }
                        this.courseTitle = bookingDetails.title;
                        if (bookingDetails.unicodeTitle && bookingDetails.unicodeTitle !== null && bookingDetails.unicodeTitle !== '') {
                            this.courseTitle = bookingDetails.unicodeTitle;
                        } else {
                            this.courseTitle = bookingDetails.title;
                        }

                        if (this.hasDates) {
                            setTimeout(() => {
                                const tabSecond = <HTMLElement>document.querySelector('.tab-section .tabs-wrapper .tabs li:last-of-type');
                                tabSecond.click();
                            }, 100);
                        }
                        this._$status.next(bookingDetails.status);
                        this._configurationService.$siteSettings.subscribe((data) => {
                            if (data && data.length > 0) {
                                const _countriesData = data.filter((f) => f.key.toLowerCase() === 'countries')[0];
                                _countriesData['value'].filter((obj) => {
                                    if (obj.code === bookingDetails.bookingPerson.country) {
                                        this.countryName = obj.name;
                                    }
                                });
                            }
                        });
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
            if (this._configurationService.isPartnerPage()) {
                this._configurationService.currentPortal$.subscribe((portalId) => {
                    if (portalId) {
                    this._portalConfigurationService.loadPortalPreferences(portalId).then((preferences) => {
                        const _dateFormat = this._portalConfigurationService.getPortalDateFormat(preferences);
                        this._$dateFormat.next(_dateFormat);
                    });
                }
            });
            } else {
                this._$dateFormat.next('dd.MM.yyyy');
            }
        }
    }

    private translateSalutationsAndCountries(bookingperson, billingperson) {
        this.salutationData = this._configurationService.$allSalutationsByLanguage.getValue();
        this.countriesData = this._configurationService.$allCountriesByLanguage.getValue();
        const salutationBooking = this.salutationData.filter((item) => item.key === bookingperson.salutation);
        const salutationBilling = this.salutationData.filter((item) => item.key === billingperson.salutation);
        const countryBooking = this.countriesData.filter((item) => item.key === bookingperson.country);
        const countryBilling = this.countriesData.filter((item) => item.key === billingperson.country);
        this._$translatedBookingSalutation.next(salutationBooking[0]?.value);
        this._$translatedBookingCountry.next(countryBooking[0].value);
        this._$translatedBillingSalutation.next(salutationBilling[0]?.value);
        this._$translatedBillingCountry.next(countryBilling[0].value);
    }
}
